import React from "react";

const Gifts = ({ player }) => {
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <h3
        style={{
          fontSize: "24px",
          fontWeight: "600",
          color: "#50868f",
          marginBottom: "20px",
          paddingBottom: "10px",
          borderBottom: "2px solid #50868f",
        }}
      >
        {player.name}'s Gift Rewards
      </h3>

      {player.gifts.length === 0 ? (
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <p style={{ color: "#666", fontStyle: "italic" }}>
            No gifts claimed yet
          </p>
        </div>
      ) : (
        <div
          style={{
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#fff",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                  }}
                >
                  Gift ID
                </th>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                  }}
                >
                  Name
                </th>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                  }}
                >
                  Points Used
                </th>
                <th
                  style={{
                    backgroundColor: "#50868f",
                    color: "#fff",
                    padding: "16px",
                    textAlign: "left",
                  }}
                >
                  Claimed Date
                </th>
              </tr>
            </thead>
            <tbody>
              {player.gifts.map((gift) => (
                <tr
                  key={gift.gift_id}
                  style={{
                    borderBottom: "1px solid #ddd",
                    transition: "background-color 0.3s ease",
                    ":hover": {
                      backgroundColor: "#f9f9f9",
                    },
                  }}
                >
                  <td style={{ padding: "16px", textAlign: "left" }}>
                    {gift.gift_id}
                  </td>
                  <td
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "500",
                    }}
                  >
                    {gift.gift_name}
                    {gift.customized_name && (
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#666",
                          marginTop: "4px",
                        }}
                      >
                        Custom: {gift.customized_name}
                      </div>
                    )}
                  </td>
                  <td style={{ padding: "16px", textAlign: "left" }}>
                    <span
                      style={{
                        padding: "6px 12px",
                        borderRadius: "12px",
                        backgroundColor:
                          gift.status === "Delivered" ? "#e6f7ee" : "#e6f2ff",
                        color:
                          gift.status === "Delivered" ? "#10B981" : "#3B82F6",
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      {gift.status}
                    </span>
                  </td>
                  <td style={{ padding: "16px", textAlign: "left" }}>
                    {gift.score_used}
                  </td>
                  <td style={{ padding: "16px", textAlign: "left" }}>
                    {new Date(gift.claimed_at).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Gifts;
